// extracted by mini-css-extract-plugin
export default {"userProfileAvatar":"UserSettingsPage_userProfileAvatar__mXa4X"};